import 'primereact/resources/themes/saga-green/theme.css';

function GreenTheme(): null {
  return null;
}

export default GreenTheme;
